
    var riot = require('riot')
    
riot.tag2('profile', '<yield></yield> <modal name="signin" title="Sign In" onclose="{close}" savetext="Sign In" onsave="{handleSignIn}" esckey="{true}"> <signin onsignin="{parent.handleSignedIn}" hidebutton="{true}" hidesignup="{false}" hideforgotpassword="{parent.opts.hideforgotpassword}" forgot-password-custom-message="{parent.opts.forgotPasswordCustomMessage}" redirect="{parent.opts.onLoginRedirect}"></signin> </modal> <modal name="profile" title="Profile" onclose="{close}" savetext="Save" onsave="{handleSaveProfile}"> <div class="profile"> <form class="form-horizontal"> <div class="row"> <div class="col-xs-6 col-xs-offset-3 col-md-4 col-md-offset-0"> <div class="avatar"> <uploadimage on-click="{parent.uploadimage}"><img riot-tag="img_loader" riot-src="/images/users-images/user{parent.parent.userId}.jpg?u={parent.parent.cachebuster}" default="/images/users-images/default.jpg"></uploadimage> </div> </div> <div class="col-xs-12 col-md-7"> <forminput name="first_name" label="First Name" onupdate="{parent.handleUpdate}" value="{parent.user.first_name}" width1="3" width2="9"></forminput> <forminput name="surname" label="Surname" onupdate="{parent.handleUpdate}" value="{parent.user.surname}" width1="3" width2="9"></forminput> <forminput name="email" label="Email" onupdate="{parent.handleUpdate}" value="{parent.user.email}" width1="3" width2="9"></forminput> </div> </div> <div class="row"> <div class="col-md-12"> <forminput name="company" label="Company/Organisation" onupdate="{parent.handleUpdate}" value="{parent.user.company}" width1="4" width2="8"></forminput> <formtextarea name="address" label="Address" onupdate="{parent.handleUpdate}" value="{parent.user.address}" width1="4" width2="8"></formtextarea> <forminput name="county" label="County" onupdate="{parent.handleUpdate}" value="{parent.user.county}" width1="4" width2="8"></forminput> <forminput name="postcode" label="Postcode" onupdate="{parent.handleUpdate}" value="{parent.user.postcode}" width1="4" width2="8"></forminput> <forminput name="country" label="Country" onupdate="{parent.handleUpdate}" value="{parent.user.country}" width1="4" width2="8"></forminput> <forminput name="phone1" label="Telephone" onupdate="{parent.handleUpdate}" value="{parent.user.phone1}" width1="4" width2="8"></forminput> <forminput name="phone2" label="Mobile" onupdate="{parent.handleUpdate}" value="{parent.user.phone2}" width1="4" width2="8"></forminput> </div> </div> </form> <button onclick="{parent.handleLogOut}" class="btn btn-secondary logout-btn">Logout</button> </div> </modal>', '.profile .logout-btn { margin-bottom: -130px; } .profile .avatar { border: 1px solid #ccc; padding: 10px; margin-bottom: 20px; } .profile .avatar img { width: 100%; } .profile .row { margin-bottom: 10px; }', 'onclick="{open}"', function(opts) {
var loginApi, logoutApi, profileApi, resource;

resource = require('riot-kit/utils/apiResource.coffee');

loginApi = new resource('/duocms/api/login', true);

logoutApi = new resource('/duocms/api/logout', true);

profileApi = new resource('/duocms/api/users/me', true);

this.on('mount', function() {
  return this.title = 'Sign In';
});

this.open = (function(_this) {
  return function() {
    return loginApi.get(function(data) {
      if ((data != null ? data.id : void 0) != null) {
        _this.userId = data.id;
        _this.user = data;
        _this.update();
        return _this.tags.profile.show();
      } else {
        return _this.tags.signin.show();
      }
    });
  };
})(this);

this.handleLogOut = (function(_this) {
  return function() {
    return logoutApi.get(function() {
      return _this.handleLoggedOut();
    });
  };
})(this);

this.handleLoggedOut = (function(_this) {
  return function() {
    _this.tags.profile.hide();
    return setTimeout(function() {
      return window.location.pathname = '/';
    }, 500);
  };
})(this);

this.close = (function(_this) {
  return function() {};
})(this);

this.handleUpdate = (function(_this) {
  return function(update) {
    _this.user[update.name] = update.value;
    return _this.update();
  };
})(this);

this.handleSignIn = (function(_this) {
  return function() {
    return _this.tags.signin.tags.signin.signin();
  };
})(this);

this.handleSignedIn = (function(_this) {
  return function() {
    _this.tags.signin.hide();
    return setTimeout(function() {
      return window.location.pathname = window.location.pathname;
    }, 500);
  };
})(this);

this.handleSaveProfile = (function(_this) {
  return function() {
    _this.user.id = null;
    return profileApi.save(_this.user, function(data) {
      return _this.tags.profile.hide();
    });
  };
})(this);

this.cachebuster = "";

this.uploadimage = (function(_this) {
  return function(file) {
    var formData, self, xhr;
    formData = new FormData();
    formData.append("file", file);
    xhr = new XMLHttpRequest();
    xhr.open('POST', '/duocms/api/users/upload_avatar?_csrf=' + window.csrf, true);
    self = _this;
    xhr.onload = function() {
      var resp;
      resp = JSON.parse(this.response);
      self.cachebuster = +(new Date());
      return self.update();
    };
    return xhr.send(formData);
  };
})(this);
});
    
  